module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "allowFieldSelection": true,
      "dateFields": _vm.dateFields,
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main with-leads-table with-leads-table-active",
    attrs: {
      "slot": "main",
      "id": "dashboard-canvas"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [_c('h1', [_vm._v("Policies")]), _vm._v(" "), _c('div', {
    staticClass: "pivots-wrapper"
  }, [(_vm.pivot_branch_options.length) ? _c('span', {
    staticClass: "pivot label"
  }, [_vm._v("\n                Branch: "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showBranchOptions = !_vm.showBranchOptions
      }
    }
  }, [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v(_vm._s(_vm.countPivots(_vm.pivots.branch_code)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBranchOptions),
      expression: "showBranchOptions"
    }],
    staticClass: "pivot-select-wrapper"
  }, [_c('header', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.toggleBranchOptions
    }
  }, [(_vm.pivots.branch_code.length) ? _c('span', [_vm._v("Unselect all")]) : _c('span', [_vm._v("Select all")])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pivots.branch_code),
      expression: "pivots.branch_code"
    }],
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pivots, "branch_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.pivot_branch_options), function(p) {
    return _c('option', {
      domProps: {
        "value": p[0]
      }
    }, [_vm._v(_vm._s(p[1]))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.pivot_type_options.length) ? _c('span', {
    staticClass: "pivot label"
  }, [_vm._v("\n                Policy Type: "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTypeOptions = !_vm.showTypeOptions
      }
    }
  }, [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v(_vm._s(_vm.countPivots(_vm.pivots.policy_type_code)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTypeOptions),
      expression: "showTypeOptions"
    }],
    staticClass: "pivot-select-wrapper"
  }, [_c('header', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.toggleTypeOptions
    }
  }, [(_vm.pivots.policy_type_code.length) ? _c('span', [_vm._v("Unselect all")]) : _c('span', [_vm._v("Select all")])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pivots.policy_type_code),
      expression: "pivots.policy_type_code"
    }],
    attrs: {
      "multiple": "",
      "size": "10"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pivots, "policy_type_code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.pivot_type_options), function(p) {
    return _c('option', {
      domProps: {
        "value": p[0]
      }
    }, [_vm._v(_vm._s(p[1]))])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('ls-metric-banner', {
    staticClass: "col-lg-6 col-xs-12",
    attrs: {
      "series": _vm.summary
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("Branches")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Policies by Branch")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'by_branch',
      "bc-data": _vm.stats.chart_by_branch.series,
      "bc-layout": _vm.stats.chart_by_branch.layout
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Premiums by Branch")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'premium_by_branch',
      "bc-data": _vm.stats.premium_by_branch.series,
      "bc-layout": _vm.stats.premium_by_branch.layout
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Commissions by Branch")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'commission_by_branch',
      "bc-data": _vm.stats.commission_by_branch.series,
      "bc-layout": _vm.stats.commission_by_branch.layout
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', [_vm._v("Policy Types")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Policies by Type")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'by_type',
      "bc-data": _vm.stats.chart_by_type.series,
      "bc-layout": _vm.stats.chart_by_type.layout
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Premiums by Type")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'premium_by_type',
      "bc-data": _vm.stats.premium_by_type.series,
      "bc-layout": _vm.stats.premium_by_type.layout
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Commissions by Type")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'commission_by_type',
      "bc-data": _vm.stats.commission_by_type.series,
      "bc-layout": _vm.stats.commission_by_type.layout
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('policies-table', {
    attrs: {
      "pivots": _vm.pivots,
      "datesRange": _vm.datesRange
    },
    on: {
      "loaded": _vm.refreshData
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5bb318"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/Policies.vue
// module id = 613
// module chunks = 0